
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import PictureButton from '@devsisters/ui-careers/lib/PictureButton';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"picturebutton"}}>{`PictureButton`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { PictureButton } from '@devsisters/ui/careers';
// 또는 import PictureButton from '@devsisters/ui-careers/lib/PictureButton';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h2>기본</h2>\n<PictureButton\n  imageWidth={500}\n  imageHeight={281}\n  imageSrc=\"https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a0ec8840-de86-11e8-ad6b-dbc6c1f40db4.png\"\n  style={{\n    display: \'block\',\n    width: \'200px\',\n  }}\n>\n  버튼 내용\n</PictureButton>\n<h2>링크</h2>\n<PictureButton\n  imageWidth={500}\n  imageHeight={281}\n  imageSrc=\"https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a0ec8840-de86-11e8-ad6b-dbc6c1f40db4.png\"\n  style={{\n    display: \'block\',\n    width: \'200px\',\n  }}\n  link={[\n    \'#link1\',\n    function({ to, className, style, children }) {\n      return (\n        <a href={to} className={className} style={style}>\n          {children}\n        </a>\n      )\n    },\n  ]}\n>\n  버튼 내용\n</PictureButton>'} __scope={{props: this ? this.props : props,PictureButton}}>
  <h2>기본</h2>
  <PictureButton
    imageWidth={500}
    imageHeight={281}
    imageSrc='https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a0ec8840-de86-11e8-ad6b-dbc6c1f40db4.png'
    style={{
      display: 'block',
      width: '200px',
    }}>
    버튼 내용
  </PictureButton>
  <h2>링크</h2>
  <PictureButton
    imageWidth={500}
    imageHeight={281}
    imageSrc='https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a0ec8840-de86-11e8-ad6b-dbc6c1f40db4.png'
    style={{
      display: 'block',
      width: '200px',
    }}
    link={[
      '#link1',
      function({ to, className, style, children }) {
        return (
          <a href={to} className={className} style={style}>
            {children}
          </a>
        )
      },
    ]}>
    버튼 내용
  </PictureButton>
</Playground>
           </MDXTag>
  }
}
  